export enum ConstantsRolesProps {
  "g-automation-assignator" = "g-automation-assignator",
  "g-automation-sincronizer" = "g-automation-sincronizer",
}

export enum RolesProps {
  G_AUTOMATION_ADMIN = "g-automation-admin",
  G_AUTOMATION_FORM_VENTANERO = "g-co-ventaneros-todos",
}
